import * as React from 'react';

import { LibContext } from '~/contexts/LibContext';
import { styled } from '~/styled';

import { outerTheme } from '../Header/styles';
import { SearchResults } from './SearchResults';

const Panel = styled.div(({ theme }) => {
  return `
    width: 100vw;

    background: #fafafa; // not in theme
    position: fixed;
    z-index: 50;
    padding: 0px ${theme.space.space16} ${theme.space.space16};
    overflow-y: scroll;

    height: calc(100vh - ${outerTheme.globals.mobileSearchHeight}px);

    @media (min-width: ${theme.breakpoints[2]}) {
      height: calc(100vh - ${outerTheme.globals.headerAndNavHeight}px);
    }
  `;
});

const ResultsContainer = styled.div(
  `
    max-width: 1390px; // not in theme
    margin: auto;
  `,
);

export const SearchResultsPanel = () => {
  const { internalSearchState } = React.useContext(LibContext);

  if (!internalSearchState.query) {
    return null;
  }

  return (
    <Panel>
      <ResultsContainer>
        <SearchResults />
      </ResultsContainer>
    </Panel>
  );
};
